
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface VariablesEditorProps {
  variablesJson: string;
  variablesValid: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export function VariablesEditor({ variablesJson, variablesValid, onChange }: VariablesEditorProps) {
  return (
    <div>
      <Alert className="mb-4 bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-600" />
        <AlertTitle className="text-blue-800">Template Variables</AlertTitle>
        <AlertDescription className="text-blue-700">
          Define the variables available in this template. This will serve as documentation for code that sends this email.
        </AlertDescription>
      </Alert>
      
      <div className="grid gap-2">
        <Label htmlFor="variables" className="flex items-center justify-between">
          Variables (JSON format)
          {!variablesValid && (
            <span className="text-sm text-red-500">Invalid JSON format</span>
          )}
        </Label>
        <Textarea 
          id="variables" 
          className="font-mono text-sm"
          value={variablesJson} 
          onChange={onChange}
          rows={10}
        />
      </div>
      
      <div className="mt-4">
        <h3 className="font-medium mb-2">Example:</h3>
        <pre className="bg-gray-50 p-4 rounded-md text-sm overflow-auto">
{`{
  "userName": "User's full name",
  "courseTitle": "Title of the course",
  "completionDate": "Date the course was completed"
}`}
        </pre>
      </div>
    </div>
  );
}
